/**
 * Maps an intl locale string to the Optimizely locale format for GraphQl queries or URL segments.
 */
export const mapIntlLocaleToOptimizelyLocale = (locale: string) => {
  if (locale === 'zh-Hant') {
    return 'zh-CHT';
  }

  if (locale === 'zh-Hans') {
    return 'zh-CN';
  }

  return locale;
};
